/**
 * Communications API - SMS and Email sending, history, search
 */
import axios from '@/api/client'

const BASE = '/crm/comm'

export const communicationsApi = {
  sendSms(data) {
    return axios.post(`${BASE}/send-sms/`, data)
  },

  sendEmail(data) {
    return axios.post(`${BASE}/send-email/`, data)
  },

  aiImproveDraft(data) {
    return axios.post(`${BASE}/ai-improve/`, data)
  },

  getSmsHistory(params) {
    return axios.get(`${BASE}/sms-history/`, { params })
  },

  getEmailHistory(params) {
    return axios.get(`${BASE}/email-history/`, { params })
  },

  getEmailSignature(params) {
    return axios.get(`${BASE}/email-signature/`, { params })
  },

  getOutboundMailboxes() {
    return axios.get(`${BASE}/outbound-mailboxes/`)
  },

  searchRecipients(q, type = 'sms') {
    return axios.get(`${BASE}/search-recipients/`, { params: { q, type } })
  },

  getCustomerContacts(customerId) {
    return axios.get(`${BASE}/customer-contacts/`, { params: { customer_id: customerId } })
  },

  uploadAttachment(file) {
    const formData = new FormData()
    formData.append('file', file)
    return axios.post(`${BASE}/upload-attachment/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
}

// Office-wide SMS Inbox (Call Center Monitor feed) + AI intent tags
const SMS_BASE = '/crm/sms'

export const smsInboxApi = {
  getFeed(params) {
    return axios.get(`${SMS_BASE}/feed/`, { params })
  },
  getConversation(phone, opts = {}) {
    // opts.classify=true asks the backend to also return the client-type
    // classification (new/lead/existing/reengage) — used by the inbound SMS toast
    // badge. Omitted by default so the frequent drawer/monitor loads stay cheap.
    const params = { phone }
    if (opts.classify) params.classify = 1
    return axios.get(`${SMS_BASE}/conversation/`, { params })
  },
  getConversations(params) {
    // Grouped-by-phone inbox. Optional: limit/before/after (Messages portal
    // append-only pages), q (domain-wide search), phones (targeted refresh).
    return axios.get(`${SMS_BASE}/conversations/`, { params })
  },
  markRead(phone) {
    return axios.post(`${SMS_BASE}/mark-read/`, { phone })
  },
  markReplied(phone) {
    // Operator confirmation: client already got an acceptable answer — clear it
    // from "Missed SMS" without sending a new reply.
    return axios.post(`${SMS_BASE}/mark-replied/`, { phone })
  },
  getUnreadCount() {
    return axios.get(`${SMS_BASE}/unread-count/`)
  },
  reply(data) {
    return axios.post(`${SMS_BASE}/reply/`, data)
  },
  getTags() {
    return axios.get(`${SMS_BASE}/tags/`)
  },
  createTag(data) {
    return axios.post(`${SMS_BASE}/tags/`, data)
  },
  updateTag(tagId, data) {
    return axios.patch(`${SMS_BASE}/tags/${tagId}/`, data)
  },
  deleteTag(tagId) {
    return axios.delete(`${SMS_BASE}/tags/${tagId}/`)
  },
}

export default communicationsApi
